/* eslint-disable */
import data from './data.json'
import Home from './pages/Home'

import About from './pages/About'
import Service from './pages/Service'

import GetService from './pages/getService'
import GetService2 from './pages/getService2'

import Careers from './pages/Careers'
import CareersInternal from './pages/careersInternal'
import VacancyApply from './pages/vacancyApply'

import News from './pages/news'
import Telim from './pages/telim'
import NewsInternal from './pages/newsInternal'

import Personal from './pages/Personal'
import BussinesConsulting from './pages/bussinesConsulting'
import JoinOurFamily from './pages/JoinOurFamily'

import HireStep1 from './pages/hireStep1'
import HireStep2 from './pages/hireStep2'
import RemoteStep1 from './pages/remoteStep1'
import RemoteStep2 from './pages/remoteStep2'

import Legal from './pages/term&conditions/legal'
import Privacy from './pages/term&conditions/privacy'
import Cookie from './pages/term&conditions/cookie'
import Term from './pages/term&conditions/term'
import Disclaimer from './pages/term&conditions/disclaimer'

import SuccessDefault from './pages/SuccessDefault'
import SuccessDefaultV2 from './pages/SuccessDefaultV2'

import Magazine from './pages/Magazine'
import JournalForm from './pages/JournalForm'
import JournalForm2 from './pages/JournalForm2'

import Library from './pages/Library'
import BookDetails from './pages/BookDetails'
import Calculator from './pages/Calculator'
import Calculator1 from './pages/Calculator1'
import Calculator2 from './pages/Calculator2'
import Calculator3 from './pages/Calculator3'
import Calculator4 from './pages/Calculator4'
import Calculator5 from './pages/Calculator5'
import Calculator6 from './pages/Calculator6'
import Result1 from './pages/Result1'
import Result2 from './pages/Result2'
import Result3 from './pages/Result3'
import Result4 from './pages/Result4'
import Result5 from './pages/Result5'
import Result6 from './pages/Result6'
import Currency from './pages/Currency'
import Calendar from './pages/Calendar'
import Search from './pages/Search'

const routeItem = (id, title, path, component) => {
  return {
    id,
    title,
    path,
    component,
  }
}

const routes = {
  home: routeItem(1, data.home, '/', Home),
  about: routeItem(2, data.about_us, '/about', About),
  sevices: routeItem(3, data.services, '/services/:id', Service),
  legal: routeItem(4, data.legal, '/legal-notices', Legal),
  privacy: routeItem(5, data.privacy, '/privacy', Privacy),
  cookie: routeItem(6, data.cookie, '/cookie-policy', Cookie),
  term: routeItem(7, data.term, '/term-conditions', Term),
  disclaimer: routeItem(8, data.disclaimer, '/disclaimer', Disclaimer),
  news: routeItem(9, data.news, '/useful/news', News),
  useful: routeItem(39, data.news, '/useful', News),
  articles: routeItem(900, data.articles, '/useful/articles', News),
  post: routeItem(901, data.post, '/useful/post-events', News),
  events: routeItem(902, data.post || data.news, '/useful/events', News),
  news_internal: routeItem(
    10,
    data['news-internal'],
    '/news/:id',
    NewsInternal,
  ),
  careers: routeItem(11, data.careers, '/careers', Careers),
  vacancy_internal: routeItem(
    12,
    data['vacancy-internal'],
    '/vacancy/:id',
    CareersInternal,
  ),
  program_internal: routeItem(
    13,
    data['program-internal'],
    '/program/:id',
    CareersInternal,
  ),
  personal: routeItem(14, data.personal, '/personal', Personal),
  JoinOurFamily: routeItem(
    15,
    data['join-our-family'],
    '/join-our-family',
    JoinOurFamily,
  ),
  BussinesConsulting: routeItem(
    15,
    data['bussines-consulting'],
    '/bussines-consulting',
    BussinesConsulting,
  ),
  SuccessDefault: routeItem(
    16,
    data['success-default'],
    '/success',
    SuccessDefault,
  ),
  SuccessDefaultV2: routeItem(
    27,
    data['success-default'],
    '/success/:version',
    SuccessDefaultV2,
  ),
  magazine: routeItem(17, data.magazine, '/useful/magazine', Magazine),
  vacancy_apply: routeItem(
    18,
    data['vacancy-apply'],
    '/vacancy-apply/:id',
    VacancyApply,
  ),
  hire_step1: routeItem(19, data.hire, '/remote-hire-step1', HireStep1),
  hire_step2: routeItem(20, data.hire, '/remote-hire-step2', HireStep2),
  remote_step1: routeItem(21, data.remote, '/remote-work-step1', RemoteStep1),
  remote_step2: routeItem(22, data.remote, '/remote-work-step2', RemoteStep2),
  get_service1: routeItem(23, data['get-service'], '/get-service1', GetService),
  get_service2: routeItem(
    24,
    data['get-service'],
    '/get-service2',
    GetService2,
  ),
  journal_form: routeItem(
    25,
    data['journal-form'],
    '/journal-form-step-1',
    JournalForm,
  ),
  journal_form2: routeItem(
    26,
    data['journal-form'],
    '/journal-form-step-2',
    JournalForm2,
  ),
  library: routeItem(27, data.library, '/useful/library', Library),
  book: routeItem(28, data.book, '/book/:id', BookDetails),
  calculator: routeItem(29, data.calculator, '/useful/calculator', Calculator),
  calculator1: routeItem(
    30,
    data.calculator,
    '/useful/calculator/1',
    Calculator1,
  ),
  calculator2: routeItem(
    31,
    data.calculator,
    '/useful/calculator/2',
    Calculator2,
  ),
  calculator3: routeItem(
    32,
    data.calculator,
    '/useful/calculator/3',
    Calculator3,
  ),
  calculator4: routeItem(
    40,
    data.calculator,
    '/useful/calculator/4',
    Calculator4,
  ),
  calculator5: routeItem(
    43,
    data.calculator,
    '/useful/calculator/5',
    Calculator5,
  ),
  result1: routeItem(
    33,
    data.result,
    '/useful/calculator/1/result/:emekHaqqi/:vm/:celb_mebleg/:income_tax/:dsmf/:sigorta/:icbari/:hemkarlar/:yekun/:tutulma',
    Result1,
  ),
  result1Direct: routeItem(
    330,
    data.result,
    '/useful/calculator/1/result',
    Result1,
  ),
  result2: routeItem(
    34,
    data.result,
    '/useful/calculator/2/result/:orta/:ay/:days/:mezun',
    Result2,
  ),
  result3: routeItem(
    38,
    data.result,
    '/useful/calculator/3/result/:start/:end/:days_mezun/:days/:total/:per/:mezun/:muavinet',
    Result3,
  ),
  result3Direct: routeItem(
    39,
    data.result,
    '/useful/calculator/3/result',
    Result3,
  ),
  result4: routeItem(
    41,
    data.result,
    '/useful/calculator/4/result/:salary/:ground/:seniority/:totalGross/:netA/:netB',
    Result4,
  ),
  result4Direct: routeItem(
    42,
    data.result,
    '/useful/calculator/4/result',
    Result4,
  ),
  result5: routeItem(
    44,
    data.result,
    '/useful/calculator/5/result/:gross/:emp/:dsmf/:tax',
    Result5,
  ),
  result5Direct: routeItem(
    45,
    data.result,
    '/useful/calculator/5/result',
    Result5,
  ),
  calculator6: routeItem(
    46,
    data.calculator,
    '/useful/calculator/6',
    Calculator6,
  ),
  result6: routeItem(
    47,
    data.result,
    '/useful/calculator/6/result',
    Result6,
  ),
  result6Direct: routeItem(
    48,
    data.result,
    '/useful/calculator/result6',
    Result6,
  ),
  currency: routeItem(35, data.currency, '/useful/currency', Currency),
  calendar: routeItem(36, data.calendar, '/useful/calendar', Calendar),
  search: routeItem(37, data.search, '/search/:query', Search),
  telim: routeItem(38, data.telim, '/useful/training', Telim),
}

const routeArr = Object.values(routes)

export { routes, routeArr }
